import { PropsWithChildren } from 'react';

import { BoxProps, Container } from '@chakra-ui/react';

export type ContentContainerProps = {
  mobilePadding?: string;
  mdPadding?: string;
  contentMaxWidth?:
    | 'content-max-width'
    | 'content-max-width-lg'
    | 'content-max-width-md'
    | 'content-max-width-xl'
    | 'content-max-width-legacy'
    | 'content-max-width-2xl';
} & BoxProps;

export function ContentContainer(props: PropsWithChildren<ContentContainerProps>) {
  const {
    children,
    contentMaxWidth = 'content-max-width',
    mobilePadding = '16px',
    mdPadding = '24px',
    ...boxProps
  } = props;
  return (
    <Container
      margin='auto'
      maxW={{ base: '100%', xl: contentMaxWidth }}
      paddingStart={{ base: mobilePadding, md: mdPadding, lg: '48px', xl: '0' }}
      paddingEnd={{
        base: mobilePadding,
        md: mdPadding,
        lg: 'var(--track-padding-end, 48px)',
        xl: 'var(--track-padding-end, 0px)',
      }}
      {...boxProps}
    >
      {children}
    </Container>
  );
}
